import type { AxiosRequestConfig } from 'axios'
import merge from 'lodash.merge'

import type {
  ReportTemplate,
  ReportTemplateId,
  ReportTemplateInitializer,
  ReportTemplateMutator,
} from '@beaded/models'

import * as apiUtils from '.'

const url = '/report-template'

export const get = (
  id: ReportTemplateId,
  options: AxiosRequestConfig = {},
): Promise<{ template: ReportTemplate }> =>
  apiUtils.GET(`${url}/${id}`, options)

export const getAll = (
  options: AxiosRequestConfig = {},
): Promise<{ templates: ReportTemplate[] }> => apiUtils.GET(`${url}/`, options)

export const getByType = (
  templateType: string,
  options: AxiosRequestConfig = {},
): Promise<{ templates: ReportTemplate[] }> =>
  apiUtils.GET(
    `${url}/`,
    merge({ params: { templateType, isActive: true } }, options),
  )

export const create = (data: ReportTemplateInitializer) =>
  apiUtils.POST(`${url}/`, data)

export const update = (id: ReportTemplateId, data: ReportTemplateMutator) =>
  apiUtils.PUT(`${url}/${id}`, data)

export const remove = (id: ReportTemplateId) => apiUtils.DELETE(`${url}/${id}`)
